/* istanbul ignore file */
import $ from 'jquery';
import Promise from 'bluebird';
import { trimEndSlash, isApexDisabled } from './utils';

export const getHelpContent = (baseHelpUrl, params) => (isApexDisabled() ? Promise.resolve(null) : $.ajax({
  url: `${trimEndSlash(baseHelpUrl)}/api/apexv2api`,
  data: params,
  dataType: 'json',
}));
